import {
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { ReplaySubject, Subject, firstValueFrom, take, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';

import {
  BankAccountDto,
  SendAccountReceiverDto,
} from 'src/app/domain/models/dto/bank-account.dto';
import { BankDashDto } from 'src/app/domain/models/dto/bank.dto';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { PaymentSucessInboundComponent } from 'src/app/pages/orders/shared/components/create-order/payment-sucess-inbound/payment-sucess-inbound.component';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { AuthenticationService } from 'src/app/shared/services';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { AddBankAccountComponent } from 'src/app/pages/account/modals/add-bank-account/add-bank-account.component';

@Component({
  selector: 'app-select-bank-account',
  templateUrl: './select-bank-account.component.html',
  styleUrls: ['./select-bank-account.component.scss'],
})
export class SelectBankAccountComponent implements OnInit {
  @Input() order: any;

  private readonly notifier: NotifierService;
  boobleModalData: InboundOrderDto;
  banks: BankDashDto[] = [];
  accounts: BankAccountDto[] = [];
  company: CorporateAccountDto;
  loading: boolean;
  isMobile = false;

  selectedAccount: any = null;
  hovered: any = null;

  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private dataBottomSheet;
  @Optional()
  private bottomSheetRef: MatBottomSheetRef<AddBankAccountComponent>;

  protected _onDestroy = new Subject<void>();

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    fb: FormBuilder,
    private modalService: BoobleModalService,
    private bankAccountService: BankAccountService,
    private readonly accountService: AuthenticationService,
    private corporateAccountService: CorporateAccountService,
    private ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,

    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  selectAccount(account: any) {
    this.selectedAccount = account;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820 ? true : false;

    if (this.isMobile) {
      this.boobleModalData = this.order;
    }

    firstValueFrom(this.bankAccountService.getNewBanks()).then((value) => {
      this.banks = value.data;
    });

    this.getBankAccounts();
  }

  getBankAccounts() {
    this.bankAccountService.getAll().subscribe((getResult) => {
      getResult.data.sort((a, b) => {
        return a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1;
      });

      this.accounts = getResult.data;
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }

  sendAccountInbound() {
    const account = new SendAccountReceiverDto();

    let bank = this.banks.find(
      (item: any) => item.name === this.selectedAccount.name
    );

    account.orderId = this.isMobile ? this.order.id : this.boobleModalData.id;
    account.name = this.selectedAccount.name;

    account.code = bank.code;

    account.agency = this.selectedAccount.agency;
    account.number = this.selectedAccount.number;

    this.loading = true;
    this.ordersService.sendAccountReceiver(account).subscribe({
      next: (res) => {
        this.ordersService.updateOrderView();
        if (this.isMobile) {
          this.bottomSheet.dismiss();
        }
        this.openPaymentSuccessModal();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  openAddBankAccountModal() {
    if (this.isMobile) {
      const bottomSheetConfig = {
        data: this.order,
      };
      this.bottomSheet.open(AddBankAccountComponent, bottomSheetConfig);
    } else {
      this.modalService.present(AddBankAccountComponent, this.boobleModalData);
    }
  }

  openPaymentSuccessModal() {
    this.modalService.present(PaymentSucessInboundComponent);
  }
}
